const getters = {
  // 设备
  // device: state => state.app.device,
  // token
  token: state => state.user.token,
  // 头像
  avatar: state => state.user.avatar,
  // 用户信息
  userInfo: state => state.user.userInfo,
  // 用户按钮列表
  userButtons: state => state.user.userButtons,

  // 用户导航
  // userNav: state => {
  //   return state.user.userNav.filter(item => {
  //     return (
  //       !item.BUTTON_CODE ||
  //       state.user.userButtons.indexOf(item.BUTTON_CODE) > -1
  //     );
  //   });
  // },
  // 用户导航
  userNav: state => state.user.userNav,
  // 用户桌面列表
  userDesktop: state => state.user.userDesktop,
  // 桌面配置窗口状态
  desktopSetting: state => state.app.desktopSetting,
  // 用户身份
  userIdentity: state => state.user.userIdentity,
  //全局搜索结果
  userGolbalSearch: state => state.user.userGolbalSearch,
  //请求域名
  serveUrl: state => state.user.serveUrl,
  //
  flowServeUrl: state => state.user.flowServeUrl,
  request: state => state.user.request
};
export default getters;
